module.exports = __webpack_public_path__ + "static/img/塑身裤.611400aa.jpg";